import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
} from "@angular/material/dialog";
import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { ConfirmDialogDefaultOptions } from "@skills-app/shared/services/dialog/dialog.service";

@Component({
  standalone: false,
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["confirm-dialog.component.css"],
})
export class ConfirmDialogComponent {
  public options: ConfirmDialogModel;
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel,
  ) {
    // Update view with given values
    this.options = {
      ...data,
      ...ConfirmDialogDefaultOptions,
      buttonColors: (
        data.buttonColors ?? ConfirmDialogDefaultOptions.buttonColors
      )?.map((c) => c ?? ""),
    };
  }

  onConfirm(): void {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}

export function defaultDialogConfig(
  dialogData: ConfirmDialogModel,
): MatDialogConfig<ConfirmDialogModel> {
  return {
    maxWidth: "400px",
    data: dialogData,
  } as MatDialogConfig<ConfirmDialogModel>;
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {
  constructor(
    public title: string,
    public message: string,
    public buttonLabels?: string[],
    public buttonColors?: string[],
  ) {}
}
